import React from 'react';
import photo1 from "../../../resources/images/blog/frameMat/Capture.PNG"
import photo2 from "../../../resources/images/blog/matboard/Capture.PNG";
import photo3 from "../../../resources/images/blog/photoset2/photo1.jpg";
import photo4 from "../../../resources/images/blog/photoset2/photo8.png";
import photo5 from "../../../resources/images/blog/photoset2/photo9.jpg";



import LazyLoad from "react-lazyload";
import {Helmet} from "react-helmet";
import backgorundPhoto from "../../../resources/images/blog/oversizedMatRamsborgFrames/IMG_3419.JPG";

export default class Blog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    };

    // componentDidMount () {
    //     const script = document.createElement("script");
    //
    //     script.src = "https://io.dropinblog.com/embedjs/0d339c96-915a-4bd3-9d2c-efff341c6d48.js";
    //     script.async = true;
    //
    //     document.body.appendChild(script);
    // }

    render() {
        return <div>
            <div id="dib-posts"></div>
        </div>
    }
}